
namespace SorAraBul.PropertyManagement {

    @Serenity.Decorators.registerClass()
    export class TenantsDialog extends Serenity.EntityDialog<TenantsRow, any> {
        protected getFormKey() { return TenantsForm.formKey; }
        protected getIdProperty() { return TenantsRow.idProperty; }
        protected getLocalTextPrefix() { return TenantsRow.localTextPrefix; }
        protected getNameProperty() { return TenantsRow.nameProperty; }
        protected getService() { return TenantsService.baseUrl; }
        protected getDeletePermission() { return TenantsRow.deletePermission; }
        protected getInsertPermission() { return TenantsRow.insertPermission; }
        protected getUpdatePermission() { return TenantsRow.updatePermission; }

        protected form = new TenantsForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons().filter(x =>
                x.cssClass !== 'apply-changes-button');

            let saveAndCloseButton = Q.first(buttons, x => x.cssClass == 'save-and-close-button');
            if (saveAndCloseButton)
                saveAndCloseButton.title = 'Gönder';

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            if (this.entity.Status != TenantStatus.formGonderildi) {
                let deleteBtn = this.toolbar.findButton("delete-button");
                if (deleteBtn) {
                    deleteBtn.hide();
                }
            }
        }

        protected updateInterface() {
            super.updateInterface();

            this.applyChangesButton.hide();
        }

        protected onSaveSuccess(response) {
            const isCreate = this.isNew();

            super.onSaveSuccess(response);

            if (isCreate) {
                window.setTimeout(() =>
                    Q.notifySuccess('Kiracı bilgi formu SMS ve e-posta aracılığıyla iletildi.'), 0);
            }
        }
    }
}
